import React from 'react';

import {
  useArchivePA,
  useRestorePA,
  useRemovePA,
  useSyncPA,
} from 'scenes/CustomAudiences/PartnerAudiences/data/mutations';

import Actions from './Actions';

const PAActions = ({
  actions = [],
  data = {},
  onDelete,
  onShare,
  onEdit,
  onAddLookalikeAudiences,
  onClose,
  ...props
}) => {
  const [archiveAudience] = useArchivePA();
  const [restoreAudience] = useRestorePA();
  const [removeAudience] = useRemovePA();
  const [syncAudience] = useSyncPA();

  const handleDelete = async () => {
    await removeAudience({
      id: data.id,
      name: data.name,
    });
    onClose?.();
  };

  const handleArchive = async () => {
    await archiveAudience({
      id: data.id,
      name: data.name,
    });
  };

  const handleRestore = async () => {
    await restoreAudience({
      id: data.id,
      name: data.name,
    });
  };

  const handleSync = async () => {
    await syncAudience({
      id: data.id,
      name: data.name,
    });
  };

  const handleAddLookalikeAudiences = () => {
    onAddLookalikeAudiences(data);
  };

  const handleShare = () => {
    onShare(data);
  };

  const handleEdit = async () => {
    await onEdit({ id: data.id });
  };

  return (
    <Actions
      actions={actions}
      onSync={handleSync}
      onShare={handleShare}
      onAddLookalikeAudiences={handleAddLookalikeAudiences}
      onArchive={handleArchive}
      onRestore={handleRestore}
      onDelete={handleDelete}
      onEdit={handleEdit}
      {...props}
    />
  );
};

export default PAActions;
